import { createAction, props } from '@ngrx/store';
import { WorkflowShift } from '../workflow-shift/workflow-shift.state';
import { DateFilter } from '../date-filter/date-filter.state';

export const saveDateFilterAndWorkflowShift = createAction(
	'[Global Date Filter and Workflow Shift] Save',
	props<{ dateFilter: DateFilter; workflowShift: WorkflowShift }>()
);
